import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing Order view counts.
 * Automatically increments the view count when the order is viewed.
 *
 * @param orderId - The ID of the order
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useOrderViewCount(orderId)
 */
export function useOrderViewCount(orderId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.Order,
    value: orderId,
  })
}
